<template>
  <section 
    v-show="isShow"
    class="cookies-privacy-policy"
  >
    <div class="container">
      <div class="cookies-privacy-policy__body">
        <div class="cookies-privacy-policy__text" v-html="data.description" />
        <BaseButton
          class="cookies-privacy-policy__btn"
          @click="setToLocalStorage()"
        >
          приймаю
        </BaseButton>
      </div>
    </div>
  </section>
</template>

<script>
  import { ls } from '@/mixins/storage'
  export default {
    name: 'CookiesPrivacyPolicy',

    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },

    data () {
      return {
        isShow: true
      }
    },
    mounted () {
      this.getLocalStorage()
    },

    methods: {
      setToLocalStorage () {
        const cookies = {}
        cookies.privacy = true
        ls.set('data', cookies) 
        this.isShow = false
      },

      getLocalStorage () {
        const lsData = ls.get('data')
        if (lsData) {
          this.isShow = false
        }
      }
    }
  }
</script>

<style lang="scss">
.cookies-privacy-policy {
  position: fixed;
  left: 50%;
  bottom: 0;
  padding: 27px 0;
  width: 100%;
  z-index: 55;
  transform: translateX(-50%);
  background-color: $c-white;

  @include mobile {
    padding: 16px 0;
  }

  &__body {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__text {
    margin-right: 5px;
    font-size: 24px;
    line-height: 1.5;
    color: $c-black;

    @include tablet {
      font-size: 20px;
      line-height: 1.2;
    }

    @include mobile {
      font-size: 10px;
      line-height: 12px;
    }
  }

  &__btn {
    padding: 19px 34px !important;

    @include mobile {
      min-width: 101px !important;
      padding: 19px 18px !important;
    }
  }
}
</style>
